import React, { forwardRef, ReactElement } from 'react';
import cm from 'classnames';

import { useAppSelector } from 'store/store-hooks';
import { selectHelpMode } from 'components/app/_mediator/app-data.slice';
import { Tooltip } from 'components/UI/tooltip/tooltip';
import styles from './_elements.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  icon: React.ReactElement;
  type: 'create' | 'edit' | 'delete' | 'share' | 'access' | 'moveTo';
  onSubmit?: (e: React.MouseEvent<HTMLDivElement>) => void;
  disabled: boolean;
  tip?: string | ReactElement;
}

export const HeaderAction = forwardRef<HTMLDivElement, Props>(
  ({ type, disabled, onSubmit, icon, tip, ...rest }, ref) => {
    const helpMode = useAppSelector(selectHelpMode);
    return (
      <Tooltip tip={tip ? tip : type} showTooltip={helpMode || disabled} position="left">
        <div
          {...rest}
          ref={ref}
          className={cm(styles.HeaderAction, { [styles.disabled]: disabled })}
          data-testid={`${type}-button`}
          onClick={(e) => {
            if (!onSubmit || disabled) return;
            onSubmit(e);
          }}
        >
          {icon}
        </div>
      </Tooltip>
    );
  }
);
